import React from "react";
import Icon from "@visa/vds/icon";
import Link from "@visa/vds/link";

const DafGmrStatusLink = () => {
    return (
        <>
            <Link href="https://visawiki.trusted.visa.com/display/GMR/Registration+Input+File" inline={true} target="_blank" rel="noopener noreferrer">
                <Icon name="maximize" resolution="tiny" />
            </Link>
        </>
    );
};
export default DafGmrStatusLink;
